export default __webpack_public_path__ + "static/media/mats-external.fa9864ec.gif";